export const PAYMOB_PRO_EVENTS = {
  LAUNCH_DRAWER_VIEWED: "Pro Launch Drawer Viewed",
  LAUNCH_DRAWER_DISMISSED: "Pro Launch Drawer Dismissed",
  TRIAL_CTA_CLICKED: "Pro Trial CTA Clicked",
  TRIAL_STARTED: "Pro Trial Started",
  TRIAL_START_FAILED: "Pro Trial Start Failed",
  PLANS_VIEWED: "Pro Plans Viewed",
  OPEN_PAYMOB_ADVISOR_CLICKED: "Pro Open Paymob Advisor Clicked",
};

export const PAYMOB_PRO_EVENTS_PARAMS = {
  TRIAL_START_AT: "trial_start_at",
  TRIAL_END_AT: "trial_end_at",
  FIRST_CHARGE_AT: "first_charge_at",
  MONTHLY_FEE: "monthly_fee",
  CURRENCY: "currency",
  ERROR_CODE: "error_code",
  SUBSCRIBED_TRAIL_PLAN: "subscription_status" 
};
export const PAYMOB_PRO_VALUES = {
 TRIAL: "trial",
 ERROR_MESSAGE:"unknown_error",
}